import { Card, CardContent } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { NumberFormatter } from "@/uiCore";
import { AssistedSavingsResponse } from "../context/types";
import classes from "../summary.module.scss";
import classNames from "classnames";
import { ClockResponsiveIcon, DollarIcon, InfoIcon, LightBulbIcon } from "@/assets/icons";
import { useAppState } from "@/modules/app/useAppContext";
import { IconButton } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";

const AssistedSavingsSection = ({
  opportunities,
  time_saved,
  total_assisted_savings,
}: AssistedSavingsResponse) => {
  const { currency } = useAppState();
  return (
    <Stack direction="column" className="al-h-full">
      <Typography variant="section-heading">Savings</Typography>
      <Stack className="al-flex-1">
        <Card className={classNames(classes.assistedSavingsCard, classes.green)}>
          <CardContent className="al-h-full al-pt-4">
            <Stack direction="column" className="al-h-full" align="center" justify="center">
              <i className="al-p-2 al-rounded-full">
                <DollarIcon className="al-h-10 al-w-10" />
              </i>
              <span className="al-text-center">Money Savings</span>
              <IconButton
                variant="ghost"
                className="al-absolute al-right-0 al-top-0"
                title="Money saved during the period when users implemented the opportunities identified by the product."
              >
                <InfoIcon />
              </IconButton>
              <p className="al-text-center">
                <NumberFormatter value={total_assisted_savings} options={{ currency }} />
              </p>
            </Stack>
          </CardContent>
        </Card>
        <Card className={classNames(classes.assistedSavingsCard, classes.blue)}>
          <CardContent className="al-h-full al-pt-4">
            <Stack direction="column" className="al-h-full" align="center" justify="center">
              <i className="al-p-2 al-rounded-full">
                <ClockResponsiveIcon className="al-h-10 al-w-10" />
              </i>
              <span className="al-text-center">Time Savings</span>
              <IconButton
                variant="ghost"
                className="al-absolute al-right-0 al-top-0"
                title="Time saved during the period when users implemented the opportunities identified by the product."
              >
                <InfoIcon />
              </IconButton>
              <p className="al-text-center">{time_saved}</p>
            </Stack>
          </CardContent>
        </Card>
        <Card className={classNames(classes.assistedSavingsCard, classes.warn)}>
          <CardContent className="al-h-full al-pt-4">
            <Stack direction="column" className="al-h-full" align="center" justify="center">
              <i className="al-p-2 al-rounded-full">
                <LightBulbIcon />
              </i>
              <span className="al-text-center">Opportunities</span>
              <IconButton
                variant="ghost"
                className="al-absolute al-right-0 al-top-0"
                title="No. of money or time savings opportunities implemented during the period"
              >
                <InfoIcon />
              </IconButton>
              <p className="al-text-center">{opportunities}</p>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
};

export default AssistedSavingsSection;
